<template lang="pug">
.navbar-container
  f7-navbar
    f7-nav-left
      template(v-if="isShowBack")
        f7-link(
          v-if="popupClose"
          class="icon-link"
          icon-f7="close"
          icon-color="white"
          popup-close)
        f7-link(
          v-else
          class="icon-link"
          icon="icon-back"
          icon-color="white"
          back)
      template(v-else)
        slot(name="left")

    f7-nav-title(v-if="title") {{ title }}

    f7-nav-right
      slot(name="right")

</template>

<style lang="scss">
.navbar-container {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 500;

  .navbar {
    background-color: rgba(25, 39, 52, 1);
    height: 56px;

    &::after {
      background-color: rgba(25, 39, 52, 1);
      @media (min-width: 768px) {
        background: none;
      }
    }

    .left {
      position: absolute;

      .icon-link {
        margin: 0 15px;
        width: 100% !important;
      }
    }

    .right {
      position: absolute;
      right: 8px;

      .icon-link {
        margin: 0 15px;
        width: 100% !important;
      }
    }

    .title {
      margin-left: auto;
      @media (max-width: 768px) {
        margin-right: auto;
      }
    }
  }
}

.navbar-container ~ .page-content {
  padding-top: 56px;
}
</style>

<script>
export default {
  props: {
    title: String,
    'popup-close': { type: Boolean, default: false },
    back: { type: Boolean, default: false },
  },
  computed: {
    isShowBack() {
      return this.back || this.popupClose
    },
  },
}
</script>
